import React, { Component, ComponentType } from 'react';

export interface WithMobileAsideHandlerProps {
  openedMobileAside: boolean;
  toggleAside: () => void;
  closeAside: () => void;
  showAsideButton: boolean;
}

interface State {
  /** przechowuje informacje czy aside dla widoku mobilnego jest otwarty */
  opened: boolean;
  width: number;
  height: number;
  showAsideButton: boolean;
}

/**
 * HOC dostarczający logikę dla widoku mobilnego aplikacji.
 *
 * @param Cmp
 */
function withMobileAsideHandler(Cmp: ComponentType<any>): any {
  class Controller extends Component<any, State> {
    constructor(props: any) {
      super(props);
      this.state = {
        opened: false,
        width: this.getWidth(),
        height: this.getHeight(),
        showAsideButton: this.getWidth() <= 1500,
      } as State;
    }
    componentDidMount(): void {
      window.addEventListener('resize', this.resizeListener);
      this.resizeListener();
      this.setState(prev => ({ ...prev, showAsideButton: this.state.width <= 1500 }));
    }
    resizeListener = (): void => {
      const width = this.getWidth();
      const height = this.getHeight();
      this.setState(prev => ({ ...prev, width, height, showAsideButton: width <= 1500 }));
    };
    getWidth = (): number => window.innerWidth;
    getHeight = (): number => window.innerHeight;
    toggleAside = (): void => {
      const tabNode = document.getElementsByClassName('ant-tabs-tabpane-active')[0];
      const noScrollClassName = 'no-scroll';
      if (tabNode.classList.contains(noScrollClassName)) tabNode.classList.remove(noScrollClassName);
      else tabNode.classList.add(noScrollClassName);
      this.setState(prev => ({ ...prev, opened: !prev.opened }));
    };

    render(): React.ReactNode {
      return (
        <Cmp
          {...this.props}
          openedMobileAside={this.state.opened}
          toggleAside={this.toggleAside}
          showAsideButton={this.state.showAsideButton}
        />
      );
    }
  }
  return Controller;
}
export default withMobileAsideHandler;
